import { CheckCircle2, Mail, ShieldCheck, Trash2 } from "lucide-react";

const CONTACT_EMAIL = "biramacedo@gmail.com";

export default function DataDeletionPage() {
  const requestMail = `mailto:${CONTACT_EMAIL}?subject=Solicita%C3%A7%C3%A3o%20de%20exclus%C3%A3o%20de%20dados%20-%20Beleza%20e%20Bronze`;

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-8 text-slate-950 sm:px-6 sm:py-12">
      <div className="mx-auto max-w-3xl">
        <header className="rounded-3xl bg-slate-950 px-6 py-8 text-white shadow-lg sm:px-9 sm:py-10">
          <div className="flex items-center gap-3">
            <Trash2 className="h-7 w-7 text-emerald-300" />
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-300">
              Beleza e Bronze
            </p>
          </div>
          <h1 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl">
            Solicitação de exclusão de dados
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-300">
            Use esta página para solicitar a exclusão dos dados associados à
            plataforma ou para revogar uma autorização de integração.
          </p>
        </header>

        <section className="mt-6 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7">
          <h2 className="text-lg font-semibold">Como solicitar</h2>
          <ol className="mt-4 space-y-4 text-sm leading-6 text-slate-600">
            <li className="flex gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-xs font-semibold text-white">
                1
              </span>
              <span>
                Envie a solicitação para{" "}
                <a
                  className="font-medium text-emerald-800 underline underline-offset-2"
                  href={requestMail}
                >
                  {CONTACT_EMAIL}
                </a>
                .
              </span>
            </li>
            <li className="flex gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-xs font-semibold text-white">
                2
              </span>
              <span>
                Informe o e-mail ou telefone associado ao cadastro, o nome do
                salão e, para uma integração Instagram, o @usuário da conta
                profissional. Não envie senhas, códigos de acesso ou tokens.
              </span>
            </li>
            <li className="flex gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-xs font-semibold text-white">
                3
              </span>
              <span>
                Confirmaremos a identidade e o escopo do pedido para proteger a
                conta. Em seguida, informaremos a conclusão ou eventual retenção
                exigida por obrigação legal, prevenção a fraude ou segurança.
              </span>
            </li>
          </ol>
        </section>

        <section className="mt-4 grid gap-4 sm:grid-cols-2">
          <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <ShieldCheck className="h-5 w-5 text-emerald-700" />
            <h2 className="mt-3 font-semibold">Integração Instagram</h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              O administrador do salão também pode desconectar a conta
              profissional nas configurações de integração. Isso interrompe o
              uso do token pela plataforma para novos atendimentos.
            </p>
          </article>
          <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <CheckCircle2 className="h-5 w-5 text-emerald-700" />
            <h2 className="mt-3 font-semibold">Confirmação</h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              A confirmação é enviada pelo mesmo canal da solicitação ou por um
              canal seguro indicado durante a validação.
            </p>
          </article>
        </section>

        <section className="mt-4 rounded-2xl border border-emerald-100 bg-emerald-50 p-5 text-sm leading-6 text-emerald-950">
          <h2 className="font-semibold">English summary for platform review</h2>
          <p className="mt-2">
            To request deletion, email{" "}
            <a
              className="font-medium underline underline-offset-2"
              href={requestMail}
            >
              {CONTACT_EMAIL}
            </a>{" "}
            with the account email or phone, salon name, and professional
            Instagram username when applicable. We verify the requester and the
            scope before processing. A salon administrator can also disconnect
            the Instagram professional account from the platform settings, which
            stops future use of the authorization token.
          </p>
        </section>

        <footer className="py-8 text-center text-xs text-slate-500">
          <a
            className="inline-flex items-center gap-1 hover:text-slate-800"
            href="/politica-de-privacidade"
          >
            <Mail className="h-3.5 w-3.5" />
            Ler Política de Privacidade
          </a>
        </footer>
      </div>
    </main>
  );
}
